import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setServiceActive } from '../actions';

import Notifier from '../components/Notifier/Notifier';
import NotifierCN from '../components/Notifier/NotifierCN';

const NotifierContainer = props => (
  <div className="notifier_container">
    {!props.isCN && (
      <Notifier
        content={props.content}
        // hidden={!props.available}
        hidden={false}
        // eslint-disable-next-line react/jsx-no-bind
        handleOpenClick={props.setServiceActive.bind(this, true)}
        // eslint-disable-next-line react/jsx-no-bind
        handleCloseClick={props.setServiceActive.bind(this, false)}
      />
    )}
    {props.isCN && <NotifierCN content={props.content} />}
  </div>
);

const mapStateToProps = (state, ownProps) => {
  const newProps = {
    available: state.service.available,
    content: state.content.service.notifier,
  };

  const override = state.content.overrides;
  if (override && override[ownProps.country]) {
    const { service = {} } = override[ownProps.country];
    if (service.notifier) {
      newProps.content = service.notifier;
    }
  }

  return newProps;
};

const mapDispatchToProps = dispatch => {
  return {
    setServiceActive: active => dispatch(setServiceActive(active)),
  };
};

NotifierContainer.defaultProps = {
  content: {},
  isCN: false,
};

NotifierContainer.propTypes = {
  content: PropTypes.objectOf(PropTypes.string),
  isCN: PropTypes.bool,
  // available: PropTypes.bool.isRequired,
  setServiceActive: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotifierContainer);
